module.exports = __webpack_public_path__ + "img/liquor.33f6580e.svg";